import React from 'react';

const LoadingOverlay = ({ show, message = 'Loading...', subMessage, progress }) => {
  if (!show) return null;
  const hasProgress = typeof progress === 'number' && progress >= 0 && progress <= 100;
  return (
    <div className="absolute inset-0 z-50 flex items-center justify-center bg-white/70 backdrop-blur-sm">
      <div className="flex flex-col items-center text-deep-brown w-64" role="status" aria-live="polite">
        <div className="animate-spin rounded-full h-10 w-10 border-2 border-deep-brown border-t-transparent mb-3" />
        <p className="text-sm font-medium text-center">{message}</p>
        {subMessage && (
          <p className="mt-1 text-xs text-warm-gray text-center">{subMessage}</p>
        )}
        {hasProgress && (
          <div className="w-full mt-3">
            <div className="w-full h-2 bg-warm-gray/20 rounded-full overflow-hidden" aria-label="Progress bar" aria-valuemin={0} aria-valuemax={100} aria-valuenow={Math.round(progress)}>
              <div
                className="h-2 bg-gold transition-all duration-150"
                style={{ width: `${Math.max(0, Math.min(100, progress))}%` }}
              />
            </div>
            <div className="mt-1 text-xs text-warm-gray text-right">{Math.round(progress)}%</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default LoadingOverlay;
